import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'
import {Helmet} from 'react-helmet'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {DashboardPlannedAccessesCard} from '@/features/dashboard/components/dashboard-planned-accesses-card/DashboardPlannedAccessesCard'
import {DashboardAccessesCard} from '@/features/dashboard/components/dashboard-accesses-card/DashboardAccessesCard'
import {DashboardDeviationCard} from '@/features/dashboard/components/dashboard-deviation-card/DashboardDeviationCard'
import {DashboardSection} from '@/features/dashboard/components/dashboard-section/DashboardSection'
import {DashboardPatientAbsencesCard} from '@/features/dashboard/components/dashboard-patient-absences-card/DashboardPatientAbsencesCard'
import {DashboardTherapistAbsencesCard} from '@/features/dashboard/components/dashboard-therapist-absences-card/DashboardTherapistAbsencesCard'
import {DashboardDoctorAbsencesCard} from '@/features/dashboard/components/dashboard-doctor-absences-card/DashboardDoctorAbsencesCard'
import {DashboardOpenProjectsCard} from '@/features/dashboard/components/dashboard-open-projects-card/DashboardOpenProjectsCard'
import {DashboardPicClosuresCard} from '@/features/dashboard/components/dashboard-pic-closures-card/DashboardPicClosuresCard'
import {DashboardAccreditationPatientsCard} from '@/features/dashboard/components/dashboard-accreditation-patients-card/DashboardAccreditationPatientsCard'
import {DashboardOperationalAccessesPerformanceChart} from '@/features/dashboard/components/dashboard-operational-accesses-performance-chart/DashboardOperationalAccessesPerformanceChart'
import {StyledDashboardOperationalWrapper} from './style'
import {DashboardFilters} from '@/features/dashboard/components/dashboard-filters/DashboardFilters'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'

export const DashboardOperational = () => {
    const {t} = useTranslation()

    return (
        <StyledDashboardOperationalWrapper>
            <Helmet title={`${t('commons:dashboard')} | ${t('dashboard:operational')}`} />
            <DashboardFilters />
            <ScrollArea scrollbar={<Scrollbar />}>
                <Flexbox direction="column" fullWidth>
                    <DashboardSection title={t('dashboard:operational_performance')}>
                        <Flexbox direction="column" gap={6} fullWidth>
                            <DashboardOperationalAccessesPerformanceChart />
                            <Grid columns={3} gap={6} fullWidth>
                                <DashboardPlannedAccessesCard />
                                <DashboardAccessesCard />
                                <DashboardDeviationCard />
                            </Grid>
                        </Flexbox>
                    </DashboardSection>

                    <DashboardSection title={t('dashboard:ongoing_activities')}>
                        <Grid columns={3} gap={6} fullWidth>
                            <DashboardOpenProjectsCard />
                            <DashboardPicClosuresCard />
                            <DashboardAccreditationPatientsCard />
                        </Grid>
                    </DashboardSection>

                    <DashboardSection title={t('dashboard:absences')}>
                        <Grid columns={3} gap={6} fullWidth>
                            <DashboardPatientAbsencesCard />
                            <DashboardTherapistAbsencesCard />
                            <DashboardDoctorAbsencesCard />
                        </Grid>
                    </DashboardSection>
                </Flexbox>
            </ScrollArea>
        </StyledDashboardOperationalWrapper>
    )
}
